import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Icons, Modal, Text, Button, Grid } from '@/theme/index';

interface ReferralConfirmationProps {
  closeModal: () => void;
  open: boolean;
  email: string;
}

export function ReferralConfirmation({
  closeModal,
  open,
  email,
}: ReferralConfirmationProps) {
  const { navigate } = useAppConfigContext().routingUtils;
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const navigateToDashboard = () => {
    navigate('/dashboard');
    closeModal();
  };

  return (
    <Modal open={open} onClose={closeModal}>
      <Grid container justifyContent="center" gap={3}>
        <Grid item>
          <Icons.CheckCircle sx={{ fontSize: '4rem' }} color="primary" />
        </Grid>
        <Grid item width={{ sm: 'initial' }}>
          <Text variant="h4" textAlign="center" data-testId="confirmation-text">
            Thank you for inviting {email} to {brandName}!
          </Text>
        </Grid>
        <Grid
          item
          container
          justifyContent="center"
          gap={3}
          direction={{ xs: 'column-reverse', sm: 'row' }}
          alignItems="center"
        >
          <Grid item width={{ xs: '80%', sm: '15rem' }}>
            <Button
              variant="outlined"
              color="success"
              sx={{ width: '100%' }}
              onClick={navigateToDashboard}
              data-testId="confirmation-dashboard-button"
            >
              {' '}
              Go to Dashboard{' '}
            </Button>
          </Grid>
          <Grid item width={{ xs: '80%', sm: '15rem' }}>
            <Button
              variant="contained"
              color="success"
              sx={{ width: '100%' }}
              onClick={closeModal}
              data-testId="confirmation-invite-button"
            >
              {' '}
              Send another invite{' '}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
